import { Injectable } from '@angular/core';
import { Adapter } from '@app/core/adapter';
import { Tag } from '@app/shared/models/tag.model';

@Injectable()
export class TagAdapter implements Adapter<Tag> {
    adapt(data: any): Tag {
        return {
            id: data.id || 0,
            name: data.value || '',
            group: data.group || '',
            href: data.href || '',
        } as Tag;
    }
}
